<template>
    <p class="lender-info-text">
        <span class="lender-info-value">{{ loanAmountDisplay }}</span>
        <span class="lender-info-label t-small">{{ rangeLabel }}</span>
    </p>
</template>

<script>
import { formatCurrency } from '@js/utilities/number.js'

export default {
    props: ['loanRange', 'rangeLabel'],

    computed: {
        loanAmountDisplay() {
            if (this.loanRange?.min !== this.loanRange?.max) {
                return `${formatCurrency(this.loanRange?.min)} - ${formatCurrency(this.loanRange?.max)}`
            }

            return `${formatCurrency(this.loanRange?.min)}`
        },
    },
}
</script>
